import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import ProductCard from '../components/ProductCard';
import { products } from '../data/products';
import './Home.css';

const heroSlides = [
  {
    image: "https://images.unsplash.com/photo-1610030469983-98e550d6193c?w=1400&q=85",
    label: "Bridal Collection 2024",
    title: "Draped in\nTimeless Grace",
    sub: "Handcrafted couture for every occasion"
  },
  {
    image: "https://images.unsplash.com/photo-1617627143750-d86bc21e42bb?w=1400&q=85",
    label: "Festive Sarees",
    title: "Woven with\nRoyal Tradition",
    sub: "Authentic silks from India's finest looms"
  },
  {
    image: "https://images.unsplash.com/photo-1583391733956-3750e0ff4e8b?w=1400&q=85",
    label: "New Arrivals",
    title: "Modern Silhouettes,\nAncient Craft",
    sub: "Contemporary designs rooted in heritage"
  }
];

const categories = [
  { name: "Bridal Wear", image: "https://images.unsplash.com/photo-1610030469983-98e550d6193c?w=500&q=80", count: "24 pieces" },
  { name: "Silk Sarees", image: "https://images.unsplash.com/photo-1617627143750-d86bc21e42bb?w=500&q=80", count: "36 pieces" },
  { name: "Festive", image: "https://images.unsplash.com/photo-1583391733956-3750e0ff4e8b?w=500&q=80", count: "18 pieces" },
  { name: "Party Wear", image: "https://images.unsplash.com/photo-1594938298603-c8148c4b4d8c?w=500&q=80", count: "29 pieces" },
];

export default function Home() {
  const [slide, setSlide] = React.useState(0);
  const timerRef = useRef();

  useEffect(() => {
    timerRef.current = setInterval(() => setSlide(s => (s + 1) % heroSlides.length), 5000);
    return () => clearInterval(timerRef.current);
  }, []);

  const featured = products.slice(0, 4);

  return (
    <div className="home">
      {/* Hero */}
      <section className="hero">
        {heroSlides.map((s, i) => (
          <div key={i} className={`hero-slide ${i === slide ? 'active' : ''}`}>
            <img src={s.image} alt={s.title} />
            <div className="hero-overlay" />
          </div>
        ))}
        <div className="hero-content">
          <p className="hero-label">{heroSlides[slide].label}</p>
          <h1 className="hero-title">{heroSlides[slide].title}</h1>
          <p className="hero-sub">{heroSlides[slide].sub}</p>
          <div className="hero-ctas">
            <Link to="/collections" className="hero-btn-primary">Explore Collection</Link>
            <Link to="/about" className="hero-btn-ghost">Our Story</Link>
          </div>
        </div>
        <div className="hero-dots">
          {heroSlides.map((_, i) => (
            <button key={i} className={`dot ${i === slide ? 'active' : ''}`} onClick={() => setSlide(i)} />
          ))}
        </div>
        <div className="hero-scroll">
          <span>Scroll</span>
          <div className="scroll-line" />
        </div>
      </section>

      {/* Marquee */}
      <div className="marquee-wrap">
        <div className="marquee-track">
          {[...Array(3)].map((_, r) => (
            <span key={r}>
              Bridal Lehengas &nbsp;✦&nbsp; Silk Sarees &nbsp;✦&nbsp; Anarkali Suits &nbsp;✦&nbsp; Sharara Sets &nbsp;✦&nbsp; Custom Stitching &nbsp;✦&nbsp;
            </span>
          ))}
        </div>
      </div>

      {/* Categories */}
      <section className="categories-section">
        <div className="section-header">
          <p className="section-label">Curated For You</p>
          <h2 className="section-title">Shop by Category</h2>
        </div>
        <div className="categories-grid">
          {categories.map((cat, i) => (
            <Link to="/collections" key={i} className="cat-card">
              <img src={cat.image} alt={cat.name} />
              <div className="cat-overlay" />
              <div className="cat-body">
                <h3>{cat.name}</h3>
                <p>{cat.count}</p>
                <span className="cat-arrow">→</span>
              </div>
            </Link>
          ))}
        </div>
      </section>

      {/* Featured Products */}
      <section className="featured-section">
        <div className="section-header">
          <p className="section-label">Hand Picked</p>
          <h2 className="section-title">Featured Collection</h2>
        </div>
        <div className="products-grid">
          {featured.map(p => <ProductCard key={p.id} product={p} />)}
        </div>
        <div className="view-all-wrap">
          <Link to="/collections" className="view-all-btn">View All Collections</Link>
        </div>
      </section>

      {/* Banner */}
      <section className="mid-banner">
        <img src="https://images.unsplash.com/photo-1594938298603-c8148c4b4d8c?w=1400&q=80" alt="Dhadee Boutique" />
        <div className="mid-banner-overlay" />
        <div className="mid-banner-content">
          <p className="section-label" style={{color: 'var(--gold-light)'}}>Exclusive Offer</p>
          <h2>Up to 30% Off<br />on Bridal Collections</h2>
          <p>Limited time. Hurry before they're gone.</p>
          <Link to="/collections" className="hero-btn-primary">Shop Now</Link>
        </div>
      </section>

      {/* Testimonials */}
      <section className="testimonials-section">
        <div className="section-header">
          <p className="section-label">Love Notes</p>
          <h2 className="section-title">What Brides Say</h2>
        </div>
        <div className="testimonials-grid">
          {[
            { name: "Priya Anand", text: "My bridal lehenga from Dhadee was absolutely stunning. The craftsmanship is unmatched and I felt like a queen on my wedding day.", loc: "Chennai" },
            { name: "Kavitha Rajan", text: "The Kanjivaram saree I purchased is of exceptional quality. Dhadee Boutique truly understands the art of Indian weaving.", loc: "Coimbatore" },
            { name: "Meena Krishnan", text: "I've shopped here three times and every piece has been a treasure. The personal attention is what sets Dhadee apart.", loc: "Nagercoil" },
          ].map((t, i) => (
            <div key={i} className="testimonial-card">
              <div className="stars">★★★★★</div>
              <p className="testimonial-text">"{t.text}"</p>
              <div className="testimonial-author">
                <span className="author-name">{t.name}</span>
                <span className="author-loc">{t.loc}</span>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Trust Badges */}
      <section className="trust-section">
        {[
          { icon: "🧵", title: "Authentic Handcraft", desc: "Every piece made by skilled artisans" },
          { icon: "🚚", title: "Free Shipping", desc: "On all orders above ₹5,000" },
          { icon: "↩️", title: "Easy Returns", desc: "7-day hassle-free return policy" },
          { icon: "🔒", title: "Secure Payments", desc: "100% safe & encrypted checkout" },
        ].map((b, i) => (
          <div key={i} className="trust-item">
            <span className="trust-icon">{b.icon}</span>
            <h4>{b.title}</h4>
            <p>{b.desc}</p>
          </div>
        ))}
      </section>
    </div>
  );
}
